<template>
  <v-dialog v-model="show" scrollable max-width="1200px" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Add Pax</v-col>
        </v-row>
      </v-card-title>
      <v-container fluid>
        <v-row align="center" justify="center" dense>
          <v-col cols="12" sm="2">
            <client-title-list-select
              v-model="title"
              dense
              :outlined="outlinedInputs"
              clearable
            ></client-title-list-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              label="Name"
              v-model="name"
              clearable
              dense
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Surname"
              v-model="surname"
              clearable
              dense
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Email"
              v-model="email"
              clearable
              dense
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
              label="Phone"
              v-model="mobile"
              clearable
              dense
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          :items="items"
          :headers="headers"
          v-model="selectedClients"
          show-select
          single-select
          ref="dataTable"
        ></v-data-table>

        <v-row v-if="debug">
          <v-col>
            <code>{{ filter }}</code>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn
          @click="$emit('close')"
          color="secondary"
          id="closePaxDialogueBtn"
          text
          >Close</v-btn
        >
        <v-btn
          color="primary"
          text
          :disabled="!isValid"
          id="addAndContinuePaxDialogueBtn"
          @click="onAddSelected"
          >Add and Continue</v-btn
        >
        <v-btn
          color="primary"
          :disabled="!isValid"
          id="addPaxDialogueBtn"
          @click="onAddSelected('close')"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ALL_CLIENTS_SEARCH_QUERY } from "../../../../constants/graphql";
import ClientTitleListSelect from "../../shared/ClientTitleListSelect.vue";
export default {
  components: { ClientTitleListSelect },
  name: "add-pax-dialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      debug: false,
      selectedClients: [],
      title: "",
      name: "",
      surname: "",
      email: "",
      mobile: "",
      searchTimeout: null,
      searchDebounceTime: 500, // 500ms delay
      debouncedFilter: {
        name_contains: undefined,
        surname_contains: undefined,
        email_contains: undefined,
        mobile_contains: undefined,
        title_contains: undefined,
      },
      headers: [
        {
          text: "Title",
          sortable: false,
          value: "title",
          name: "title",
        },
        {
          text: "Name",
          sortable: false,
          value: "name",
          name: "name",
        },
        {
          text: "Surname",
          sortable: false,
          value: "surname",
          name: "surname",
        },
        {
          text: "Email",
          sortable: false,
          value: "email",
          name: "email",
        },
        {
          text: "Mobile",
          sortable: false,
          value: "mobile",
          name: "mobile",
        },
        {
          text: "Telephone",
          sortable: false,
          value: "telephone",
          name: "telephone",
        },
      ],
      titles: ["Mr.", "Mrs.", "Miss", "Ms.", "Dr."],
      first: 50,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.selectedClients.length > 0 || this.newClientIsValid;
    },
    newClientIsValid() {
      return this.name != "" && this.surname != "";
    },
    filter() {
      return { ...this.debouncedFilter };
    },
    items() {
      return this.clients && this.clients.edges
        ? this.clients.edges.map((item) => ({ ...item.node }))
        : [];
    },
    newClient() {
      return {
        id: null, //http://tracker.globetrack.ie/issues/5870
        title: this.title,
        name: this.name,
        surname: this.surname,
        email: this.email,
        mobile: this.mobile,
      };
    },
  },
  methods: {
    clear() {
      this.title = "";
      this.name = "";
      this.surname = "";
      this.email = "";
      this.mobile = "";
      this.selectedClients = [];
      // Clear the debounced filter when clearing the form
      this.debouncedFilter = {
        name_contains: undefined,
        surname_contains: undefined,
        email_contains: undefined,
        mobile_contains: undefined,
        title_contains: undefined,
      };
      clearTimeout(this.searchTimeout);
    },
    debounceFilterUpdate(filterKey, value) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        console.log("searchTimeout", filterKey, value);
        this.debouncedFilter[filterKey] = value !== "" ? value : undefined;
      }, this.searchDebounceTime);
    },
    onAddSelected(action) {
      if (this.selectedClients.length > 0) {
        this.$emit("add", { ...this.selectedClients[0] });
      } else {
        this.$emit("add", { ...this.newClient });
      }

      if (action == "close") {
        this.$emit("close");
      }
      this.selectedClients = [];
    },
    onAddNew() {
      this.$emit("add", { ...this.newClient });
    },
  },

  watch: {
    show(newVal) {
      newVal && this.clear();
    },
    name(newVal) {
      this.debounceFilterUpdate("name_contains", newVal);
    },
    surname(newVal) {
      this.debounceFilterUpdate("surname_contains", newVal);
    },
    email(newVal) {
      this.debounceFilterUpdate("email_contains", newVal);
    },
    mobile(newVal) {
      this.debounceFilterUpdate("mobile_contains", newVal);
    },
    title(newVal) {
      this.debounceFilterUpdate("title_contains", newVal);
    },
  },

  apollo: {
    clients: {
      query: ALL_CLIENTS_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          filter: this.filter,
          first: this.first,
        };
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.clients.totalCount;
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderAddPaxDialog.vue